import React, { Component } from 'react';
import notFound from '../../../utils/images/404.png';
import { PATH } from '../../../utils/Constants';
import { LanguageProvider, useLanguage } from '../../../utils/common/LanguageContext';

/**
 * @package virtuowl
 * @type {React.ComponentClass}
 */

// HOC to inject language context into class component
const withLanguage = (Component) => {
    return (props) => {
        const { t } = useLanguage();
        return <Component {...props} t={t} />;
    };
};

class NotFound extends Component {
    //handleHomePage
    handleHomePage = () => {
        this.props.history.push(PATH.INDEX);
    };

    render() {
        return (
            <div className="fixed h-full w-full left-0 top-0">
                <div className="w-full h-full flex items-center justify-center bg-neutral">
                    <div className="flex h-screen flex-col">
                        <div className="m-auto text-center">
                            <img src={notFound} alt="" className="mb-8" />
                            <p className="text-3xl font-medium mb-4">
                                {this.props.t('oopsPageNotFound')}
                            </p>
                            <p>{this.props.t('sorryPageDoesntExist')}</p>
                            <button
                                className="border border-primary text-primary py-1.5 px-6 rounded-full mt-6 font-weight-semibold"
                                onClick={() => {
                                    this.handleHomePage();
                                }}
                            >
                                {this.props.t('backToHome')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const ConnectedNotFound = withLanguage(NotFound);

export default (props) => (
    <LanguageProvider>
        <ConnectedNotFound {...props} />
    </LanguageProvider>
);
